module.exports = __webpack_public_path__ + "static/media/IMG_2094.bfded2ca.JPG";